import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'mention',
    standalone: true
})
export class MentionPipe implements PipeTransform {
    private nameRegex = /@\|([\w\s]+)\|/gi;

    transform(value: string): string {
        if (!value)
            return;

        return value.replace(this.nameRegex, (match, name) => {
            return `<span class="mention">@${name}</span>`;
        })
    }
}
